const getOffersLoading = (offerIds) => (state) => offerIds.some(
  (offerId) => (state.orders.offersLoading || []).includes(offerId),
)

export default getOffersLoading
